module.exports = __webpack_public_path__ + "img/MemeETC (18).e355f63a.jpeg";